import React from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import DashboardScreen from './screens/DashboardScreen';
import CatalogingScreen from './screens/CatalogingScreen';
import CirculationScreen from './screens/CirculationScreen';

import './App.css';
import LocationScreen from './screens/LocationScreen';
import DigitizationScreen from './screens/DigitizationScreen';
import ReceptionScreen from './screens/ReceptionScreen';
import MainLayout from './layouts/MainLayout';
import { useSelector } from 'react-redux';
import LoginScreen from './screens/LoginScreen';
import NotFoundScreen from './screens/NotFoundScreen';
import PrivateRoute from './validators/PrivateRoute';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import RegistryScreen from './screens/RegistryScreen';
import HistoryScreen from './screens/HistoryScreen';
import RegistryScreenIndicadores from './screens/RegistryScreenIndicadores';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#4D4D4D'
    }
  }
});

function App() {
  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo } = userSignin;


  return (
    <MuiThemeProvider theme={theme}>
      <BrowserRouter>
        <MainLayout userInfo={userInfo}>
          <Switch>
            <Route path='/login' component={LoginScreen} />

            <Route path='/' exact>
              <Redirect to="/registry" />
            </Route>
            {/* <PrivateRoute path='/dashboard' component={DashboardScreen} exact></PrivateRoute>
            <PrivateRoute path='/cataloging' component={CatalogingScreen} exact></PrivateRoute>
            <PrivateRoute path='/circulation' component={CirculationScreen} exact></PrivateRoute>
            <PrivateRoute path='/location' component={LocationScreen} exact></PrivateRoute>
            <PrivateRoute path='/digitization' component={DigitizationScreen} exact></PrivateRoute>
            <PrivateRoute path='/reception' component={ReceptionScreen} exact></PrivateRoute> */}
            <PrivateRoute path='/registry' component={RegistryScreen} exact></PrivateRoute>
            <PrivateRoute path='/registry-indicadores' component={RegistryScreenIndicadores} exact></PrivateRoute>
            {/*<PrivateRoute path='/history' component={HistoryScreen} exact></PrivateRoute> 
            <Route component={NotFoundScreen} />*/}
          </Switch>
        </MainLayout>
      </BrowserRouter>
    </MuiThemeProvider>
  );


}

export default App;
